import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Home from "@/components/site/Home";
import SpecialtyPage from "@/components/site/SpecialtyPage";
import {
  LaboratorPage, PachetePage, SpecialitatiListPage,
  RecenziiPage, DesprePage, ContactPage,
} from "@/components/site/Pages";
import { PoliticaConfidentialitate, PoliticaCookies, TermeniConditii } from "@/components/site/Legal";
import Footer from "@/components/site/Footer";
import StickyPhoneBar from "@/components/site/StickyPhoneBar";
import CookieConsent from "@/components/site/CookieConsent";
import WhatsAppButton from "@/components/site/WhatsAppButton";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100); return; }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/laborator" element={<LaboratorPage />} />
            <Route path="/pachete" element={<PachetePage />} />
            <Route path="/specialitati" element={<SpecialitatiListPage />} />
            <Route path="/specialitati/:slug" element={<SpecialtyPage />} />
            <Route path="/recenzii" element={<RecenziiPage />} />
            <Route path="/despre" element={<DesprePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
            <Route path="/politica-cookieuri" element={<PoliticaCookies />} />
            <Route path="/termeni-conditii" element={<TermeniConditii />} />
          </Routes>
        </main>
        <Footer />
        <StickyPhoneBar />
        <WhatsAppButton />
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
